import {useCallback, useEffect, useState} from 'react';
import axiosInstance from '../axiosInstance';

/**
 * Custom hook to fetch chat list data for weddinglyAI Chatbot
 * @returns {Object} - Object containing chat list data and related functions
 */
const useGetChatList = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isFetched, setIsFetched] = useState(false);

  const getData = useCallback(() => {
    setLoading(true)
    const baseUrl = window.localStorage.getItem("BaseURL")
    const endpoint = "/services/projectmanagement/api/ai-bot/chat/list"
    const fullUrl = baseUrl + endpoint;

    axiosInstance
      .get(fullUrl)
      .then((res) => {
        setData(res.data);
      })
      .catch(console.error)
      .finally(() => {
        setLoading(false)
        setIsFetched(true)
      });
  }, [])

  useEffect(() => {
    getData()
  }, [getData])

  return {data, loading, isFetched};
}

export default useGetChatList;
